import { ColumnsType } from 'antd/es/table/Table';
import { TeamOutput } from 'gql/types';
import { ISortOption } from 'modules/common/interfaces';
import { createSortOrderFactory } from 'modules/common/utils/sort/createSortOrderFactory';
import TeamActionsButtons from 'modules/donor/components/TeamActionsButtons';
import { TeamListSort } from 'modules/donor/components/TeamsTable/interfaces';
import { TeamTitleFormSchema } from 'modules/donor/components/TeamsTable/schema';
import { Dispatch, SetStateAction } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { getTranslation } from 'utils/getTranslation';

import Header from '../TeamCollapse/components/Header';

const t = getTranslation('donor.GroupsTable');
type Props = {
  isEditMode: boolean;
  onToggleEditMode: (value: boolean) => void;
  form: UseFormReturn<TeamTitleFormSchema>;
  currentTeam: TeamOutput | undefined;
  setCurrentTeam: Dispatch<SetStateAction<TeamOutput | undefined>>;
  sort?: ISortOption<TeamListSort>;
  showSorterTooltip?: boolean;
};

export const getTeamsColumns = ({
  isEditMode,
  onToggleEditMode,
  form,
  currentTeam,
  setCurrentTeam,
  sort,
  showSorterTooltip,
}: Props): ColumnsType<TeamOutput> => {
  const getDefaultSort = createSortOrderFactory<TeamListSort>(sort);

  return [
    {
      title: t('teams'),
      render: (row: TeamOutput) => (
        <Header
          isEditMode={isEditMode && row === currentTeam}
          controlled={{ control: form.control, name: 'title' }}
          team={row}
          errorMessage={form.formState.errors.title?.message}
        />
      ),
      align: 'center',
      key: TeamListSort.Title,
      sorter: true,
      sortOrder: getDefaultSort(TeamListSort.Title),
      showSorterTooltip,
    },
    {
      title: t('total'),
      render: (row: TeamOutput) =>
        `${t('total')} : ${row.donors?.length} ${t('donors').toLowerCase()}`,
      align: 'center',
      key: TeamListSort.Total,
      sorter: true,
      sortOrder: getDefaultSort(TeamListSort.Total),
      showSorterTooltip,
    },
    {
      title: t('action'),
      render: (row: TeamOutput) => (
        <TeamActionsButtons
          team={row}
          isEditMode={isEditMode && row === currentTeam}
          onToggleEditMode={(value: boolean) => {
            setCurrentTeam(row);
            form.reset({ title: row.title });
            onToggleEditMode(value);
          }}
          form={form}
        />
      ),
      align: 'center',
    },
  ];
};
